import * as React from "react";

/**
 * Палитра и хэш повторяют avatarBg()/initials() из макетов pda-design
 * (не UserAvatar кита: тот рисует градиенты, здесь — плоские тона).
 * variant="hashed" — цвет по хэшу имени (--avatar-1..8, «Список документаций»/РП/ГИП);
 * variant="flat" — фиксированный серый (--avatar-flat-*, Автор в «Списке проектов»,
 * см. docs/REDESIGN-PLAN.md §2.6 — намеренная иерархия, не ошибка).
 *
 * Опциональный src — фото профиля; при ошибке загрузки остаются инициалы.
 */
const AVATAR_VARS = [
  "--avatar-1",
  "--avatar-2",
  "--avatar-3",
  "--avatar-4",
  "--avatar-5",
  "--avatar-6",
  "--avatar-7",
  "--avatar-8",
];

function avatarColorVar(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) % 9973;
  }
  return `var(${AVATAR_VARS[h % AVATAR_VARS.length]})`;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return (parts[0]?.[0] ?? ``) + (parts[1]?.[0] ?? ``);
}

export type InitialsAvatarVariant = "hashed" | "flat";

export interface InitialsAvatarProps {
  name: string;
  size?: number;
  variant?: InitialsAvatarVariant;
  className?: string;
  /** URL фото (object URL / http). Если нет или onError — показываются инициалы. */
  src?: string | null;
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  name, size = 26, variant = `hashed`, className, src,
}) => {
  const [imageFailed, setImageFailed] = React.useState(false);
  React.useEffect(() => {
    setImageFailed(false);
  }, [src]);

  const showImage = !!src && !imageFailed;

  return (
    <span
      className={className}
      style={{
        flex: `0 0 auto`,
        width: size,
        height: size,
        borderRadius: `50%`,
        background: showImage
          ? `transparent`
          : variant === `flat` ? `var(--avatar-flat-bg)` : avatarColorVar(name),
        color: variant === `flat` ? `var(--avatar-flat-color)` : `#fff`,
        fontSize: size <= 24 ? 10 : 10.5,
        fontWeight: 600,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        textTransform: `uppercase`,
        overflow: `hidden`,
        position: `relative`,
      }}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          draggable={false}
          onError={() => setImageFailed(true)}
          style={{
            width: `100%`,
            height: `100%`,
            objectFit: `cover`,
            display: `block`,
          }}
        />
      ) : (
        initialsOf(name)
      )}
    </span>
  );
};
